import { render, staticRenderFns } from "./CartReviewGlobalProduct.vue?vue&type=template&id=6dd39c5a&scoped=true&"
import script from "./CartReviewGlobalProduct.vue?vue&type=script&lang=ts&"
export * from "./CartReviewGlobalProduct.vue?vue&type=script&lang=ts&"
import style0 from "./CartReviewGlobalProduct.vue?vue&type=style&index=0&id=6dd39c5a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6dd39c5a",
  null
  
)

export default component.exports